import React, { useState, useRef, useEffect } from "react";
import { Link, NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { TiArrowSortedDown } from "react-icons/ti";
import { OverlayTrigger, Popover, Navbar, Offcanvas, Container, Nav } from "react-bootstrap";

import MBOTLogo from "../../../assets/logo/descLogo.png";
import BellIcon from "../../../assets/misc/bellIcon.png";
import dummyProfile from "../../../assets/misc/dummyProfile.png";
import PlayStoreImg from "../../../assets/misc/Google Play.svg";
import QrPlayStoreImg from "../../../assets/misc/playstore.png";
import QrApplyStoreImg from "../../../assets/misc/applestore.png";
import AppleStoreImg from "../../../assets/misc/App Store (1).svg";
import { sidebarItems } from "../../../lib/Sidebar/Sidebar";
import { MdOutlineLogout } from "react-icons/md";
import useLogout from "../../../hooks/useLogout";
import "./MasterLayout.css";
import NotificationPopUp from "../../../pages/Notifications/notificationCenter/NotificationPopUp";
import { notificationService } from "../../../services/notificationService";
import { CERTIFICATE_STATUS_ALL } from "../../../data/certificateStatusConstants";
import { logoutUser } from "../../../redux/slices/authSlice";
import { fetchCertificateStatus } from "../../../redux/slices/certificateStatusSlice";
import { handleCurrentSelfCheckStep, handleCurrentStep, handleCurrentTSTCStep } from "../../../redux/slices/userInfoStepperSlice";

const MasterLayout = ({ children }) => {
    const profileImage = useSelector((state) => state.auth.user?.profile_path);
    const username = useSelector((state) => state.auth.user?.name);
    const userType = useSelector((state) => state.auth.user?.user_type);
    const location = useLocation();
    const { handleLogOut } = useLogout(userType);
    const [showPopover, setShowPopover] = useState(false);
    const popupRef = useRef();
    const status3 = useSelector((state) => state.certificateStatus?.data?.user?.certificates[0]?.certificate_application?.type);
    const [notifications, setNotifications] = useState([]);
    const [showBadge, setShowBadge] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const resubmitApplication = useSelector((state) => state?.certificateStatus?.data?.user?.is_resubmit_the_application);
    const certificateStatus = useSelector((state) => state?.certificateStatus?.data?.user?.certificate_applications?.type);
    const status = useSelector((state) => state.certificateStatus?.data?.user?.certificate_applications?.status);
    const dispatch = useDispatch();
    const dropdownRef = useRef(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const navigate = useNavigate();

    const toggleDropdown = () => {
        setDropdownOpen((prev) => !prev);
    };
    // Function to handle clicks outside the dropdown
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    // Add event listener for outside clicks
    useEffect(() => {
        dispatch(handleCurrentTSTCStep(1));
        dispatch(handleCurrentSelfCheckStep(1));
        dispatch(handleCurrentStep(1));
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [location.pathname]);
    useEffect(() => {
        if (status === CERTIFICATE_STATUS_ALL.DEREGISTERED) {
            dispatch(logoutUser());
        }
        if (status === CERTIFICATE_STATUS_ALL.REMOVAL_DEATH) {
            dispatch(logoutUser());
        }
    }, [status, location.pathname]);

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const response = await notificationService.getAllNotifications(1, 3);
                const fetchedNotifications = response?.data?.data?.data;
                setNotifications(fetchedNotifications);

                if (fetchedNotifications.length > 0) {
                    const latestNotificationId = fetchedNotifications[0].id;
                    const storedNotificationId = localStorage.getItem("latestNotificationId");

                    if (storedNotificationId && latestNotificationId !== storedNotificationId) {
                        setShowBadge(true);
                    } else {
                        console.warn("No new notifications.");
                    }

                    localStorage.setItem("latestNotificationId", latestNotificationId);
                }
            } catch (error) {
                console.error("Error fetching notifications: ", error);
            }
        };

        fetchNotifications();
        const interval = setInterval(fetchNotifications, 5000);
        return () => clearInterval(interval);
    }, []);

    const handleClosePopup = () => {
        setShowPopover(false);
        setShowBadge(false);
    };

    useEffect(() => {
        setShowBadge(false);
    }, [location.pathname]);

    // const adjustedSidebarItems = sidebarItems[userType]?.filter((item) => {
    //     if ((certificateStatus !== 1 && item.name === "CPD Activities" && certificateStatus !== 2 && item.name === "CPD Activities") || (status3 !== 3 && item.name === "CPD Activities" && status3 !== 4 && item.name === "CPD Activities")
    //         || (resubmitApplication === 1 && item.name === "CPD Activities")) {
    //         return false;
    //     }
    //     // if (((certificateStatus === 2 || certificateStatus === 1 || resubmitApplication === 1) && item.name === "CPD Activities")) {
    //     //     return false;
    //     // }
    //     return true;
    // });
    const adjustedSidebarItems = sidebarItems[userType]?.filter((item) => {
        if (item.name === "CPD Activities") {
            if (certificateStatus === 1 || certificateStatus === 2) {
                return false;
            }
            if (resubmitApplication === 1) {
                return false;
            }
            if (status3 !== 3 && status3 !== 4) {
                return false;
            }
            return true;
        }
        return true; // Include all other items by default
    });
    useEffect(() => {
        dispatch(fetchCertificateStatus()).then(() => {});
    }, [dispatch, location.pathname]);

    const handleDashboardClick = () => {
        navigate("/dashboard");
    };

    return (
        <div id="wrapper-user">
            <Navbar bg="light" expand="lg" className="navbar-container-user">
                <Container fluid className="d-flex align-items-center h-100">
                    <Navbar.Brand className="h-100 d-flex align-items-center">
                        <img src={MBOTLogo} alt="MBOT Logo" className="img-fluid d-lg-none" style={{ height: "87%" }} onClick={handleDashboardClick} />
                    </Navbar.Brand>
                    <div className="d-flex gap-3">
                        <div className="d-flex gap-3 align-items-center ">
                            <div ref={popupRef} style={{ cursor: "pointer" }}>
                                <OverlayTrigger
                                    trigger="click"
                                    placement="bottom-end"
                                    show={showPopover}
                                    onToggle={() => setShowPopover(!showPopover)}
                                    overlay={
                                        <Popover id="avatar-popover" className="dashboard-avatar-popover">
                                            <Popover.Body style={{ maxWidth: "500px !important" }}>
                                                <NotificationPopUp handleClosePopup={handleClosePopup} />
                                            </Popover.Body>
                                        </Popover>
                                    }
                                >
                                    <span className="position-relative">
                                        <img src={BellIcon} alt="Notifications" className="cursor-pointer" />
                                        {showBadge && (
                                            <span className="position-absolute notification-badge translate-middle p-1 bg-danger border border-light rounded-circle">
                                                <span className="visually-hidden">New alerts</span>
                                            </span>
                                        )}
                                    </span>
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div className="dropdown d-none d-md-none d-lg-block d-sm-none" ref={dropdownRef}>
                            <div className={`center-alignment cursor-pointer ${dropdownOpen ? "show" : ""}`} type="button" onClick={toggleDropdown} aria-expanded={dropdownOpen}>
                                <div className="preview-container-header">
                                    <img src={profileImage || dummyProfile} alt="Preview" className="preview-image" />
                                </div>
                                <TiArrowSortedDown className="text-gray-950" style={{ marginLeft: "6px", width: "10px" }} />
                                <ul className={`dropdown-menu dropdown-menu-end px-2 ${dropdownOpen ? "show" : ""}`} data-bs-popper="static">
                                    <div className="d-flex align-items-center cursor-default">
                                        <div>
                                            <img
                                                src={profileImage || dummyProfile}
                                                alt="Profile"
                                                style={{
                                                    width: "38px",
                                                    height: "38px",
                                                    borderRadius: "100%",
                                                }}
                                            />
                                        </div>
                                        <div className="text-gray-300 fw-500 ms-2 text-nowrap text-uppercase">{username}</div>
                                    </div>
                                    <div className="dropdown-divider"></div>
                                    <div onClick={handleLogOut} className="text-gray-300">
                                        <MdOutlineLogout className="sidebar-item-icon" /> Logout
                                    </div>
                                </ul>
                            </div>
                        </div>
                        <Navbar.Toggle aria-controls="offcanvasNavbar" className="d-lg-none" onClick={() => setShowOffcanvas(true)} />
                        <Navbar.Offcanvas
                            id="offcanvasNavbar"
                            aria-labelledby="offcanvasNavbarLabel"
                            placement="end"
                            className="d-lg-none navbar-offcanvas-toggle"
                            show={showOffcanvas}
                            onHide={() => setShowOffcanvas(false)}
                        >
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title id="offcanvasNavbarLabel">
                                    <div className="d-flex align-items-center cursor-default">
                                        <div>
                                            <img
                                                src={profileImage || dummyProfile}
                                                alt="Profile"
                                                style={{
                                                    width: "38px",
                                                    height: "38px",
                                                    borderRadius: "100%",
                                                }}
                                            />
                                        </div>
                                        <div className="text-gray-300 fw-500 ms-2 text-wrap">{username}</div>
                                    </div>
                                </Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body className="d-flex flex-column justify-content-between">
                                <div>
                                    <Nav className="justify-content-end flex-grow-1 pe-3 gap-3">
                                        {adjustedSidebarItems?.map((item) => (
                                            <NavLink to={item?.path} key={item?.name} onClick={() => setShowOffcanvas(false)} className="text-decoration-none text-gray-250 fw-500 fs-6">
                                                <div className={`${location.pathname === item?.path ? "active" : ""}`}>
                                                    <span>{item?.name}</span>
                                                </div>
                                            </NavLink>
                                        ))}
                                    </Nav>

                                    <div className="dropdown-divider mt-3"></div>
                                    <div onClick={handleLogOut} className="text-gray-300 mt-3">
                                        <MdOutlineLogout className="sidebar-item-icon" /> Logout
                                    </div>
                                </div>
                                <div className="d-flex flex-column gap-3 store-links">
                                    <Link to={process.env.REACT_APP_PLAYSTORE_LINK} target="_blank" className="d-flex align-items-center justify-content-between">
                                        <img src={PlayStoreImg} alt="Preview" className="playstore-img" />
                                        <img src={QrPlayStoreImg} alt="Preview" className="qr-playstore-img" />
                                    </Link>
                                    <Link to={process.env.REACT_APP_APPLESTORE_LINK} target="_blank" className="d-flex align-items-center justify-content-between">
                                        <img src={AppleStoreImg} alt="Preview" className="playstore-img" />
                                        <img src={QrApplyStoreImg} alt="Preview" className="qr-playstore-img" />
                                    </Link>
                                </div>
                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                    </div>
                </Container>
            </Navbar>
            <aside className="sidebar-container-user d-none d-lg-flex">
                <div className="sidebar-overlay-user">
                    <button style={{ margin: "0px", padding: "0px", border: "none", background: "unset" }} onClick={handleDashboardClick}>
                        <img src={MBOTLogo} alt="MBOT Logo" className="overlay-header-logo" />
                    </button>
                    <div className="d-flex flex-column mt-3 cursor-pointer sidebar-items-user">
                        {adjustedSidebarItems?.map((item) => (
                            <NavLink to={item?.path} key={item?.name} className="text-decoration-none text-gray-250 fw-500 fs-6">
                                <div className={`${location.pathname === item?.path ? "active" : ""}`}>
                                    <span>{item?.name}</span>
                                </div>
                            </NavLink>
                        ))}
                    </div>
                    <div className="d-flex gap-3 store-links">
                        <Link to={process.env.REACT_APP_PLAYSTORE_LINK} target="_blank" className="d-flex flex-column align-items-center justify-content-center">
                            <img src={QrPlayStoreImg} alt="Preview" className="qr-playstore-img" />
                            <img src={PlayStoreImg} alt="Preview" className="playstore-img" />
                        </Link>
                        <Link to={process.env.REACT_APP_APPLESTORE_LINK} target="_blank" className="d-flex flex-column align-items-center justify-content-center">
                            <img src={QrApplyStoreImg} alt="Preview" className="qr-playstore-img" />
                            <img src={AppleStoreImg} alt="Preview" className="playstore-img" />
                        </Link>
                    </div>
                </div>
            </aside>
            <section className="page-content">
                <main className="main-content-user">
                    <Outlet />
                </main>
            </section>
        </div>
    );
};

export default MasterLayout;
